import { GridColumn } from '@progress/kendo-react-grid';

const FoxGridColumn = GridColumn;

export default FoxGridColumn;
